import React, {useEffect, useState} from "react";
import SyncLoader from "react-spinners/SyncLoader";

const Loading = ({show}) => {
    if (!show) {
        return <></>;
    }

    return (
      <div className={'loading-div'} data-testid={'loadingDiv'}>
          <SyncLoader/>
      </div>
    );
};

export default Loading;